module.exports = __webpack_public_path__ + "adf69e75442b27a1c643a93a4c17683f.MP3";